export const POLLS_API = process.env.REACT_APP_POLLS_API || "https://polls.racevision.info";

function readPossibleTokenFromValue(value) {
    if (!value || typeof value !== "string") return "";

    const trimmed = value.trim();

    if (trimmed.startsWith("eyJ")) {
        return trimmed;
    }

    try {
        const parsed = JSON.parse(trimmed);

        const candidates = [
            parsed?.token,
            parsed?.access_token,
            parsed?.accessToken,
            parsed?.jwt,
            parsed?.authToken,
            parsed?.user?.token,
            parsed?.user?.access_token,
        ];

        return candidates.find((candidate) =>
            typeof candidate === "string" && candidate.startsWith("eyJ")
        ) || "";
    } catch {
        return "";
    }
}

function getAuthToken() {
    const directKeys = [
        "rv_token",
        "rv_auth_token",
        "racevision_token",
        "token",
        "access_token",
        "authToken",
        "jwt",
        "rv_auth",
        "auth",
        "user",
    ];

    for (const key of directKeys) {
        const localToken = readPossibleTokenFromValue(window.localStorage.getItem(key));
        if (localToken) return localToken;

        const sessionToken = readPossibleTokenFromValue(window.sessionStorage.getItem(key));
        if (sessionToken) return sessionToken;
    }

    for (const storage of [window.localStorage, window.sessionStorage]) {
        for (let i = 0; i < storage.length; i += 1) {
            const key = storage.key(i);
            if (!key) continue;

            const token = readPossibleTokenFromValue(storage.getItem(key));
            if (token) return token;
        }
    }

    return "";
}

export function adminAuthHeader() {
    const token = getAuthToken();

    return token
        ? { Authorization: `Bearer ${token}` }
        : {};
}

// anonyme ID pro Browser (für Dedup)
export function getOrCreateAnonId() {
    let id = localStorage.getItem("rv_polls_anon_id");
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("rv_polls_anon_id", id);
    }
    return id;
}

// roomCode via ?code=gt3x-r1
export function getRoomCodeFromQuery() {
    const p = new URLSearchParams(window.location.search);
    return (p.get("code") || "").trim();
}